import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import { IconButton } from 'components/Button';

import './index.sass';

const { block, el } = bem('certificate-form-success');

const CertificateFormSuccess = () => {

    return (
        <div className={block()}>
            <div className={el('content')}>
                <div className={el('top-block')}>
                    <div className={el('stars')} />
                    <div className={el('message')}>
                        <div className={el('title')}>
                            <Text tag={'div'} serif>{`Ваш заказ успешно оплачен `}
                            </Text>
                        </div>
                    </div>
                </div>
                <div className={el('buttons')}>
                    <IconButton name={'arrow-counter-clockwise'} to={'/certificates'} mod={'transparent-gold'}><Text>Продолжить покупки</Text></IconButton>
                    <IconButton name={'user-circle'} to={'/profile'} mod={'gold'}><Text>В личный кабинет</Text></IconButton>
                </div>
            </div>
        </div>
    )
}

export default observer(CertificateFormSuccess);
